module.exports = __webpack_public_path__ + "img/女-胃癌h.3f757e5b.png";